import { render, staticRenderFns } from "./HasPersonalPropertyDamagesQuestion.vue?vue&type=template&id=0aed3376&scoped=true"
import script from "./HasPersonalPropertyDamagesQuestion.vue?vue&type=script&lang=ts"
export * from "./HasPersonalPropertyDamagesQuestion.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0aed3376",
  null
  
)

export default component.exports